import { makeStyles } from "@material-ui/core";
import React from "react";

interface Props {
  enabled: boolean;
}

const NuclearBattery = (props: Props) => {
  const { enabled } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {enabled ? (
        <div className={classes.batteryContainer}>
          <div className={classes.terminal}>
            <div className={classes.negativeTerminal} />
            <div className={classes.positiveTerminal} />
          </div>
          <div className={classes.battery}>
            <div className={classes.terminal}>
              <div className={classes.batteryTerminal} />
              <div className={classes.batteryTerminal} />
            </div>
            <div className={classes.batteryTop} />
            <div className={classes.batteryBottom}>
              <div className={classes.batteryContent}>
                <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.6986 3.28123C9.70191 3.17322 3.17359 9.70154 3.28159 17.6982C3.38824 25.3675 9.63286 31.6121 17.3021 31.7187C25.3002 31.8281 31.8271 25.2998 31.7177 17.3031C31.6125 9.6325 25.3678 3.38787 17.6986 3.28123ZM29.3265 16.4008L22.9636 16.3939C22.9325 16.3939 22.9023 16.3832 22.8781 16.3637C22.8539 16.3442 22.837 16.317 22.8303 16.2866C22.5583 15.0995 21.8983 14.037 20.9545 13.2672C20.9305 13.2477 20.9138 13.2207 20.9071 13.1906C20.9004 13.1604 20.9041 13.1288 20.9176 13.1011L23.7422 7.39783C23.7507 7.38054 23.7627 7.36523 23.7775 7.3529C23.7922 7.34056 23.8094 7.33149 23.8279 7.32626C23.8465 7.32103 23.8659 7.31977 23.8849 7.32257C23.904 7.32536 23.9222 7.33214 23.9384 7.34246C25.4709 8.31495 26.7638 9.62121 27.7205 11.1636C28.6772 12.706 29.2729 14.4447 29.4632 16.2497C29.4653 16.2688 29.4632 16.2881 29.4573 16.3064C29.4513 16.3247 29.4415 16.3415 29.4286 16.3558C29.4157 16.37 29.4 16.3814 29.3824 16.3892C29.3648 16.3969 29.3457 16.4009 29.3265 16.4008ZM14.2328 17.7994C14.1712 17.1277 14.3182 16.4533 14.6536 15.8681C14.9891 15.2829 15.4968 14.8153 16.1075 14.529C16.7183 14.2427 17.4024 14.1516 18.0668 14.268C18.7312 14.3845 19.3436 14.7028 19.8205 15.1798C20.2975 15.6568 20.6159 16.2691 20.7323 16.9335C20.8488 17.5979 20.7576 18.2821 20.4713 18.8928C20.185 19.5036 19.7174 20.0112 19.1322 20.3467C18.547 20.6821 17.8726 20.8291 17.2009 20.7676C16.4373 20.6976 15.7223 20.3624 15.1801 19.8202C14.6379 19.278 14.3027 18.563 14.2328 17.7994V17.7994ZM11.2557 7.39783L14.0824 13.1011C14.0959 13.1288 14.0996 13.1604 14.0929 13.1906C14.0862 13.2207 14.0695 13.2477 14.0455 13.2672C13.1012 14.0368 12.4407 15.0993 12.1683 16.2866C12.1615 16.3176 12.1441 16.3452 12.1192 16.3648C12.0943 16.3844 12.0633 16.3947 12.0316 16.3939L5.6687 16.4008C5.64948 16.4009 5.63044 16.3969 5.61284 16.3892C5.59524 16.3814 5.57948 16.37 5.56658 16.3558C5.55367 16.3415 5.54392 16.3247 5.53796 16.3064C5.532 16.2881 5.52997 16.2688 5.53198 16.2497C5.72227 14.4447 6.31802 12.706 7.27471 11.1636C8.2314 9.62121 9.5243 8.31495 11.0568 7.34246C11.0731 7.33166 11.0916 7.32449 11.1109 7.32144C11.1303 7.31839 11.15 7.31953 11.1689 7.32478C11.1877 7.33003 11.2053 7.33926 11.2202 7.35187C11.2352 7.36447 11.2473 7.38015 11.2557 7.39783V7.39783ZM11.2304 27.5871L15.0797 22.5223C15.0986 22.4976 15.1254 22.4801 15.1556 22.4726C15.1858 22.4652 15.2176 22.4682 15.2459 22.4813C15.9544 22.803 16.7236 22.9693 17.5017 22.9693C18.2799 22.9693 19.049 22.803 19.7576 22.4813C19.7858 22.4682 19.8176 22.4652 19.8478 22.4726C19.878 22.4801 19.9048 22.4976 19.9237 22.5223L23.773 27.5871C23.7846 27.6023 23.793 27.6197 23.7974 27.6383C23.8019 27.6569 23.8024 27.6763 23.7989 27.6951C23.7954 27.7139 23.788 27.7318 23.7772 27.7476C23.7664 27.7633 23.7524 27.7767 23.7361 27.7867C21.8573 28.9278 19.7013 29.5312 17.5031 29.5312C15.3049 29.5312 13.1489 28.9278 11.2701 27.7867C11.2536 27.7769 11.2393 27.7637 11.2282 27.7481C11.2171 27.7324 11.2095 27.7146 11.2057 27.6957C11.202 27.6769 11.2022 27.6575 11.2065 27.6388C11.2108 27.6201 11.2189 27.6024 11.2304 27.5871V27.5871Z"
                    fill="#63E932"
                  />
                </svg>
                <p className={classes.voltageText}>+3000V</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.emptyContainer}>
          <div className={classes.terminal}>
            <div className={classes.negativeTerminal} />
            <div className={classes.positiveTerminal} />
          </div>
          <p className={classes.addText}>ADD</p>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    width: "100%",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    aspectRatio: "2 / 4",
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    background: "radial-gradient(179.43% 179.43% at 50% 50%, #FAFAFF 0%, #000000 100%)",
  },
  batteryContainer: {
    width: "90%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  batteryContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    transform: "scale(1)",
    animation: "$pulse 2s infinite",
    borderRadius: "100px",
  },
  "@keyframes pulse": {
    "0%": { transform: "scale(1.05)", boxShadow: "0 0 0 0 rgba(99, 233, 50, 0.7)" },
    "70%": { transform: "scale(1)", boxShadow: "0 0 0 50px rgba(99, 233, 50, 0)" },
    "100%": { transform: "scale(1.05)", boxShadow: "0 0 0 0 rgba(99, 233, 50, 0)" },
  },
  battery: {
    width: "100%",
    aspectRatio: "2 / 4",
    display: "flex",
    flexDirection: "column",
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
  },

  batteryTop: {
    height: "30%",
    background: "#63E932",
    border: "1px solid #000000",
    borderRadius: "4px 4px 0px 0px",
  },
  batteryBottom: {
    backgroundColor: "black",
    borderRadius: "0px 0px 4px 4px",
    height: "60%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyContainer: {
    width: "90%",
    height: "100%",
  },
  terminal: {
    display: "flex",
    justifyContent: "space-around",
  },
  positiveTerminal: {
    width: "9px",
    height: "9px",
    backgroundColor: "#BB0000",
  },
  negativeTerminal: {
    width: "9px",
    height: "9px",
    backgroundColor: "black",
  },
  batteryTerminal: {
    width: "24px",
    height: "9px",
    backgroundColor: "#A0A0A0",
    border: "1px solid #000000",
  },
  addText: {
    color: "black",
    textAlign: "center",
    marginTop: "100%",
    fontFamily: "VT323",
  },
  voltageText: {
    color: "#63E932",
    textAlign: "center",
    fontFamily: "VT323",
    fontSize: "24px",
    margin: 0,
  },
});

export default NuclearBattery;
